import React, { Suspense, lazy } from "react";
import NavBar from "./Components/NavBar";
import Home from "./Components/Home";
import Seo from "./Components/Seo";
import BackgroundBeamsLoader from "./Components/BackgroundBeamsLoader";

const About = lazy(() => import("./Components/About"));
const Experience = lazy(() => import("./Components/Experience"));
const TechStack = lazy(() => import("./Components/TechStack"));
const Projects = lazy(() => import("./Components/Projects"));
const Contact = lazy(() => import("./Components/Contact"));
const Footer = lazy(() => import("./Components/Footer"));

function App() {
  return (
    <div className="min-h-screen bg-black text-white overflow-x-clip max-w-full">
      <Seo />
      <NavBar />
      <main className="w-full max-w-full relative flex flex-col antialiased overflow-x-clip">
        <Home />
        <Suspense
          fallback={<div className="min-h-[90vh] bg-black" aria-hidden="true" />}
        >
          <About />
          <Experience />
          <TechStack />
          <Projects />
          <Contact />
          <Footer />
        </Suspense>
      </main>
      <BackgroundBeamsLoader />
    </div>
  );
}

export default App;
